import $             from 'jquery';
import template      from './template.hbs';
import FormStep      from '../../classes/form-step';
import validateEmail from '../../util/email';

const ERRORS = {
  DUPLICATE: 'This email is already in use',
  INVALID:   'Please enter a valid email address',
  UNKNOWN:   'Something went wrong. Please try again.'
};

export default new FormStep({

  template,

  $el: $('<form class="form-step step-preorder-email" />'),

  rules: {
    email: validateEmail
  },

  beforeNext( state, cb ) {
    const url = `${ window.cloudURL }/email/${ state.email }`;

    this.$el.find('.input-wrap').addClass('loading');

    $.ajax( url, {
      complete: ({ status }) => {
        this.$el.find('.input-wrap').removeClass('loading');

        if ( status === 404 ) {
          this.setState({ email_error: null });
          return this.submitWaitlist( state, cb );
        }

        let email_error = ERRORS.UNKNOWN;

        if ( status === 200 ) {
          email_error = ERRORS.DUPLICATE;
        } else if ( status === 400 ) {
          email_error = ERRORS.INVALID;
        }

        this.setState({ email_error });

        return this.render( state );
      }
    });
  },

  submitWaitlist( data, cb ) {
    const addr          = window.gis_address_components;
    const gis_id        = window.gis_id;
    const email         = data.email;
    const street_number = addr.primary_number;
    const city          = addr.city_name;
    const state         = addr.state_abbreviation;
    const postal_code   = addr.zipcode;
    const flow          = 'preorder';
    const url           = '/waitlist';

    const street = [
      addr.street_predirection,
      addr.street_name,
      addr.street_suffix,
      addr.street_postdirection
    ].filter( Boolean ).join(' ');


    const payload = {
      email,
      gis_id,
      street_number,
      street,
      city,
      state,
      postal_code,
      flow
    };

    $.ajax({ url, method: 'POST', data: payload, complete: cb });
  },

  render( state ) {
    const ext = Object.assign( {}, state, this.localState );
    return FormStep.prototype.render.call( this, ext );
  }

});
